import React from 'react';

const Slogan = () => {
  return (
    <div className="slogan-container">
      <div className="slogan-text">
        Công nghệ của cảm xúc – ánh sáng của hồn quê
      </div>
    </div>
  );
};

export default Slogan;